import { FORM_MODE, Permissions } from '@awp/constants';
import React from 'react';
import { useNotificationContext } from './NotificationsContext';
import { modeConfig } from './NotificationCommon';
import { Button } from 'react-bootstrap';
import AwpCloseCancelButtons from '../../components/AwpCloseCancelButton';
import { hasAccess } from '../Authorize';
import { handleSubmit } from './NotificationEditHandlers';

/**
 * Renders the buttons for the Notification Edit form, including Save, Cancel, and Close buttons.
 *
 * @param {object} props - The props for the NotificationEditButtons component.
 * @returns {JSX.Element} The rendered buttons component.
 */
const NotificationEditButtons = ({ props }) => {
  const context = useNotificationContext();
  const { mode, setMode } = context;

  const { readOnly, title, subscribeMode } = modeConfig[mode] || modeConfig.default;

  return mode === FORM_MODE.EDIT || mode === FORM_MODE.CREATE || mode === FORM_MODE.CLONE || subscribeMode ? (
    <AwpCloseCancelButtons
      props={props}
      isPristine={!props.dirty || props.isSubmitting}
      disableSave={!props.dirty || props.isSubmitting}
      hasAccess={hasAccess([Permissions.WritePersonalAlert, Permissions.WritePublicAlert]) || subscribeMode}
      onSaveSuccess={() => handleSubmit(props, context)}
      onConfirmedCancel={() => {
        props.resetForm();
        setMode(FORM_MODE.LIST);
      }}
    />
  ) : (
    <div className="mr-2" style={{ float: 'left' }}>
      <Button className="mr-2" variant="outline-primary" onClick={() => setMode('list')}>
        Close
      </Button>
    </div>
  );
};

export default NotificationEditButtons;
